import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f358f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Les catégories associées au produit", -1))
const _hoisted_2 = { class: "hidden" }

import { ref, onMounted, computed } from "vue";
import Tree from "vue3-treeview";
import swal from "../../../../_helpers/swal";
import ApiService from "@/_services/api.service";
import { array } from "zod";
import { useRoute } from "vue-router";

interface ITreeConfig {
    roots: string[];
    checkboxes: boolean;
    checkMode: string;
    dragAndDrop: boolean;
    editable: boolean;
}


interface ITreeNodeState {
    opened: boolean;
    disabled: boolean;
    checked: boolean;
}

interface INodes {
    [id: string]: INode;
}

interface INode {
    categoryUuid: string
    text: string;
    children?: string[];
    state?: ITreeNodeState | null;
}

interface ICategory {
    id: string;
    uuid: string;
    text: string;
    state?: ITreeNodeState | null;
    children?: [] | ICategory[];
}




export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesStep',
  setup(__props) {

// IMPORTS
const TreeConfig = ref<ITreeConfig>({
    roots: [],
    checkboxes: true,
    checkMode: "manual",
    dragAndDrop: false,
    editable: false,
});

const nodes = ref<INodes>({});

const isLoadingCategories = ref<boolean>(true);
const categoriesLevel1 = ref(Array<ICategory>());
const categoriesAndChildren = ref(Array<ICategory>());
const selectedCategoriesUuids = ref<string[]>([])
let selectedCategoriesEdition: ICategory[] = [];

onMounted(() => {
    fetchCategoriesData();
});

// functions
async function fetchCategoriesData() {
    await ApiService.get("categories", {
        params: { lvl: 1, "order[lft]": "ASC" },
    })
    .then(async ({ data }) => {
        if (data.data.length > 0) {
            data.data.forEach((category, index: number) => {
                let id = index.toString();
                let newCategory: ICategory = {
                    id: id,
                    uuid: category.uuid,
                    text: category.name,
                    children: formatChildrenToCategory(category.children, id),
                };
                categoriesLevel1.value.push(newCategory);
                categoriesAndChildren.value.push(newCategory);
            });
            hydrateCategoriesTreeview();
        }
    })
    .catch(() => {
        swal.error("Une erreur a été détectée, veuillez re essayer 3.");
        return false;
    });
    isLoadingCategories.value = false;
}

function formatChildrenToCategory(data, parentKey: string) {
    let childrenData = Array<ICategory>();
    data.forEach((item, index: number) => {
        let key = parentKey + "-" + index;
        let newCategory: ICategory = {
            id: key,
            uuid: item.uuid,
            text: item.name,
            children:
                item.children && item.children.length
                ? formatChildrenToCategory(item.children, key)
                : [],
        };
        childrenData.push(newCategory);
        categoriesAndChildren.value.push(newCategory);
    });
    return childrenData;
}

function hydrateCategoriesTreeview() {
    categoriesLevel1.value.forEach((category: ICategory) => {
        TreeConfig.value.roots.push(category.id);
    });

    categoriesAndChildren.value.forEach((category: ICategory) => {
        const categoryNode: INode = {
            text: category.text,
            categoryUuid: category.uuid,
            children: category.children && category.children.length > 0
                ? getCategoryChildrenIds(category.children)
                : []
        };

        nodes.value[category.id] = categoryNode;
    });
}

function getCategoryChildrenIds(categories: ICategory[]): string[]|[] {
    let categoryChildrenIds: string[] = [];
    categories.forEach((item: ICategory) => {
        categoryChildrenIds.push(item.id);
    });

    return categoryChildrenIds;
}

function onCategoryNodeChecked(event) {
    let categoryUuid = event.categoryUuid;
    if (!selectedCategoriesUuids.value.includes(categoryUuid)) {
        selectedCategoriesUuids.value.push(categoryUuid);
    }
}
const route = useRoute();

function onCategoryNodeUnchecked(event) {
    let categoryUuid = event.categoryUuid;
    selectedCategoriesUuids.value = selectedCategoriesUuids.value.filter(uuid => uuid !== categoryUuid);
}


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createVNode(_unref(Tree), {
        nodes: nodes.value,
        config: TreeConfig.value,
        onNodeChecked: _cache[0] || (_cache[0] = ($event: any) => (onCategoryNodeChecked($event))),
        onNodeUnchecked: _cache[1] || (_cache[1] = ($event: any) => (onCategoryNodeUnchecked($event)))
      }, null, 8, ["nodes", "config"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCategoriesUuids.value, (catItem, i) => {
        return (_openBlock(), _createBlock(_component_FormKit, {
          key: i,
          type: "checkbox",
          name: [catItem],
          value: "true"
        }, null, 8, ["name"]))
      }), 128))
    ]),
    _createVNode(_component_FormKit, {
      modelValue: selectedCategoriesUuids.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedCategoriesUuids).value = $event)),
      type: "list",
      name: "hasSelectedCategory",
      validation: "required",
      "validation-messages": {
            required: 'Votre produit doit être associé à une catégorie minimum.',
        },
      "input-class": "$reset hidden",
      "outer-class": "$reset",
      "inner-class": "$reset"
    }, null, 8, ["modelValue", "validation-messages"])
  ], 64))
}
}

})